<template>
  <VcWidget
    class="footer-links"
    size="xs"
    :border="false"
    :shadow="false"
    :collapsible="isMobile"
    :collapsed="isMobile"
  >
    <template #header-container="{ collapsible, collapsed }">
      <span class="footer-links__header">
        <span class="footer-links__title text-base">{{ linksBlock.title }}</span>

        <VcIcon
          v-if="collapsible"
          :size="16"
          :class="['footer-links__arrow', { 'footer-links__arrow--rotate': collapsed }]"
          name="chevron-up"
        />
      </span>
    </template>

    <template #default-container>
      <div v-if="linksBlock.children?.length" class="footer-links__list">
        <FooterLink
          v-for="(footerLinkChild, i) in linksBlock.children"
          :key="i"
          :title="footerLinkChild.title"
          :to="footerLinkChild.route"
        />
      </div>
    </template>
  </VcWidget>
</template>

<script setup lang="ts">
import { useBreakpoints } from "@vueuse/core";
import { BREAKPOINTS } from "@/core/constants";
import FooterLink from "./footer-link.vue";
import type { ExtendedMenuLinkType } from "@/core/types";

interface IProps {
  linksBlock: ExtendedMenuLinkType;
}

defineProps<IProps>();

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller("sm");
</script>

<!--Innovadis custom: moved scss to \client-app\assets\styles\_custom.scss -->
